
var $header         = $('header');
var aniDuration     = 250;
var easing          = 'linear';
var offset          = 180;

$(function() {
    $header.data('size', 'big');
});

function resetMenuToDefault() {
    $header.removeAttr('style');
    $header.find('.nav-top .search').removeAttr('style');
    $header.find('.logo .logo-full').removeAttr('style');
    $header.find('.logo .logo-alone').removeAttr('style');
}

function setToSmallMenu(size) {
    $header.data('size', size);

    $header.stop().transition({
        'margin-top':       '-88px'
    }, aniDuration, easing);

    // Logo mit Schweif ausblenden
    $header.find('.logo .logo-full').stop().transition({
        'opacity':  '0',
        'top':      '77px',
        'left':     '0',
        'height':   '49px',
        'width':    '111px'
    }, aniDuration, easing);

    // Logo ohne Schweif einblenden
    $header.find('.logo .logo-alone').stop().transition({
        'opacity':  '1',
        'top':      '77px',
        'left':     '0px',
        'height':   '40px',
        'width':    '111px'
    }, aniDuration, easing);

    $header.find('.nav-top .search').stop().transition({
        'top':              '-45px'
    }, aniDuration, easing);

    $header.find('.search .contact').stop().transition({
        'left':              '-100px'
    }, aniDuration, easing);
}

function setToBigMenu(size) {
    $header.data('size', size);

    $header.stop().transition({
        'margin-top':       '0px'
    }, aniDuration, easing);

    // Logo ohne Schweif ausblenden
    $header.find('.logo .logo-alone').stop().transition({
        'opacity':  '0',
        'top':      '0px',
        'left':     '0px',
        'height':   '83px',
        'width':    '231px'
    }, aniDuration, easing);

    // Logo mit Schweif einblenden
    $header.find('.logo .logo-full').stop().transition({
        'opacity':  '1',
        'top':      '0px',
        'left':     '0px',
        'height':   '102px',
        'width':    '231px'
    }, aniDuration, easing);

    $header.find('.nav-top .search').stop().transition({
        'top':              '-55px'
    }, aniDuration, easing);

    $header.find('.search .contact').stop().transition({
        'left':              '0px'
    }, aniDuration, easing);
}

var oldWidth = $(window).outerWidth();
if($(window).outerWidth() >= 768) {
    $('body').css('padding-top', $header.height() + 'px');
}
$(window).resize(function() {

    function checkOffset(top) {

        if (top > offset) {
            if ($header.data('size') == 'big' || $header.data('size') == 'default') {
                setToSmallMenu('small');
            }
        } else {
            if ($header.data('size') == 'small' || $header.data('size') == 'default') {
                setToBigMenu('big');
            }
        }
    }

    if($(window).outerWidth() >= 768) {

        $(window).bind('scroll', function () {
            checkOffset($(window).scrollTop());
        }).scroll();

        $(window).bind('touchmove', function() {
            //var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            checkOffset(($('#skrollr-body').offset().top * -1) + $header.height());
        });

    } else {
        $(window).unbind('scroll');
        $(window).unbind('touchmove');
        setToBigMenu('default');
        resetMenuToDefault();
    }

    if($(window).outerWidth() >= 768 && oldWidth < 768) {
        $('body').css('padding-top', $header.height() + 'px');
        oldWidth = $(window).outerWidth();
    } else if($(window).outerWidth() < 768 && oldWidth > 768) {
        $('body').css('padding-top', '0px');
        oldWidth = $(window).outerWidth();
    }

}).resize();

$(document).ready(function() {

    //Menü-Icon animation auslösen
    $('.menu-icon').click(function () {
        $(this).toggleClass('open');
        $('.nav0-1').slideToggle('fast');
    });

    // Prüfen ob Untermenüpunkte existieren
    var submenuitem = $('nav ul li');
    //submenuitem.find('div').prev('a').append('<span class="dropdown-icon visible-xs"><img alt="Dropdown-Icon" src="img/angle-down.svg"></span>');
    $('<span class="dropdown-icon visible-xs"><img alt="Dropdown-Icon" src="img/angle-down.svg"></span>').insertBefore('.nav0-2, .nav0-3, .nav0-4');

    // Submenüebenen (de)aktivieren
    $('.dropdown-icon').click(function () {
        submenuitem.find('div.active').prev('.dropdown-icon').removeClass('rotate');
        var sub = $(this).next('div');
        if (sub) {
            $(sub).toggleClass('active');
        }
        submenuitem.find('div.active').prev('.dropdown-icon').addClass('rotate');
    });

    if($('.slider').length) {
        $('.slider').slick({
            slidesToShow: 1,
            dots: true,
            arrows: true
        });
    }

    if($('.listboxes-slider').length) {
        $('.listboxes-slider').slick({
            slidesToShow: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: false
        });
    }

    if($('.slimslider').length) {
        $('.slimslider').slick({
            slidesToShow: 1,
            dots: true,
            arrows: true
        });
    }

    //$(".fancybox").fancybox();

    /*
    Double Tap to Go
    Author: Graffino (http://www.graffino.com)
    Version: 0.3
    Originally by Osvaldas Valutis, www.osvaldas.info
    Available for use under the MIT License
    */

    ;(function($, window, document, undefined) {
        $.fn.doubleTapToGo = function(action) {

            if (!('ontouchstart' in window) &&
                !navigator.msMaxTouchPoints &&
                !navigator.userAgent.toLowerCase().match( /windows phone os 7/i )) return false;

            if (action === 'unbind') {
                this.each(function() {
                    $(this).off();
                    $(document).off('click touchstart MSPointerDown', handleTouch);
                });

            } else {
                this.each(function() {
                    var curItem = false;

                    $(this).on('click', function(e) {
                        var item = $(this);
                        if (item[0] != curItem[0]) {
                            e.preventDefault();
                            curItem = item;
                        }
                    });

                    $(document).on('click touchstart MSPointerDown', handleTouch);

                    function handleTouch(e) {
                        var resetItem = true,
                            parents = $(e.target).parents();

                        for (var i = 0; i < parents.length; i++)
                            if (parents[i] == curItem[0])
                                resetItem = false;

                        if(resetItem)
                            curItem = false;
                    }
                });
            }
            return this;
        };
    })(jQuery, window, document);


    $('.nav0-1 li:has(ul)').doubleTapToGo();
    $('.nav0-2 li:has(ul)').doubleTapToGo();
    $('.nav0-3 li:has(ul)').doubleTapToGo();

    $('.image-link').magnificPopup({
        type:'image',
        mainClass: 'mfp-with-zoom', // this class is for CSS animation below

        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it

            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function

            // The "opener" function should return the element from which popup will be zoomed in
            // and to which popup will be scaled down
            // By defailt it looks for an image tag:
            opener: function(openerElement) {
                // openerElement is the element on which popup was initialized, in this case its <a> tag
                // you don't need to add "opener" option if this code matches your needs, it's defailt one.
                return openerElement.is('img') ? openerElement : openerElement.find('img');
            }
        }
    });

    if($('.contactpersons__item').length) {

        // Cache the highest
        var highestBox = 0;

        // Select and loop the elements you want to equalise
        $('.contactpersons__item-name').each(function () {
            // If this box is higher than the cached highest then store it
            if ($(this).height() > highestBox) {
                highestBox = $(this).height();
            }
        });

        // Set the height of all those children to whichever was highest
        $('.contactpersons__item-name').height(highestBox);

    }

});

function testCall(pagename)
{
    et_eC_Wrapper({et_et: 'N8K9mg', et_pagename: pagename});
}